export * from './Main';
export * from './Promo';
export * from './Adv';
export * from './RoadMap';
export * from './Partners';
export * from './Footer';
export * from './Team';
export * from './Buttons';
